import React, { useMemo } from 'react';
import ViewMessage from '@components/ViewMessage';
import { CircledArrowIcon, PersonProfileViewIcon } from '@repo/icons';
import { Key } from '@repo/components/tooltips';
import styles from './EmptyContact.module.scss';
import Contact from '@repo/utils/models/Contact';
import { ContactBio, ContactExperience, ContactSocialProfiles } from '@repo/components/contact';
import { useAuthContext } from '@repo/hooks';
import { useDispatch } from 'react-redux';
import upgradeAction from '@support/upgrade-action';

export default function EmptyContact() {
  return (
    <ViewMessage
      className={styles.container}
      underHeader
      icon={<PersonProfileViewIcon />}
      headline="Nurture your relationship"
      message={
        <>
          Type <Key>E</Key> to add more details
          <br />
          or add a note or reminder by typing <Key>N</Key>
        </>
      }
    />
  );
}

export function RestrictedContact({ contact }: { contact: Contact }) {
  const dispatch = useDispatch();
  const { user } = useAuthContext();
  const placeholderContact = useMemo(
    () =>
      new Contact({
        bio: `You need a Clay Pro plan to view this person's bio. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.`,
        linkedinURL: 'https://www.linkedin.com',
        githubURL: 'https://www.github.com',
        twitterURL: 'https://www.twitter.com',
        facebookURL: 'https://www.facebook.com',
        organizations: [
          {
            name: 'Lorem Ipsum Inc.',
            title: 'Capable Person',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget tempor aliquam, nisl nisl aliquet nisl, eget aliquet nisl nisl eget nisl.',
          },
          {
            name: 'Lorem Ipsum & Sons, LLC',
            title: 'Junior Capable Person',
            description:
              'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec euismod, nisl eget tempor aliquam.',
          },
        ],
      }),
    [],
  );

  return (
    <>
      <div className={styles.placeholderProfile}>
        <ContactBio contact={placeholderContact} />
        <ContactSocialProfiles contact={placeholderContact} />
        <ContactExperience contact={placeholderContact} />
      </div>
      <ViewMessage
        className={styles.container}
        underHeader
        icon={<CircledArrowIcon width="22" height="22" color="textPrimary" />}
        headline="Upgrade your account"
        message={
          <>
            You've reached the limit of
            <br />
            relationships you can view on the free
            <br />
            plan. Upgrade to view {contact.displayName},
            <br />
            take notes, set reminders, and more.
          </>
        }
        button={{
          text: 'Upgrade Account',
          onClick: upgradeAction(user, dispatch),
        }}
      />
    </>
  );
}
